module.exports = __webpack_public_path__ + "img/WOOOL_A1014.50c4e214.png";